import { Switch, Route } from "react-router-dom";
import Homepage from "../views/Homepage.jsx";
import AboutUs2 from "../views/AboutUs2";
import AboutUs from "../views/AboutUs";
import Products from "../views/Products.jsx";
import Content from "../views/Content.jsx";
import Contact from "../views/Contact.jsx";
import { Admin } from "../components/Admin/Admin.jsx";
import { ContentExp } from "../views/ContentExp/ContentExp.jsx";
import { Catalogue } from "../views/Catalogue/Catalogue.jsx";
import { UploadImg } from "../components/Admin/UploadImg.jsx";
import { Editblog } from "../components/Admin/Blog/Editblog.jsx";
Editblog;
const Routes = () => (
  <Switch>
    <Route exact path="/" component={Homepage} />
    <Route exact path="/aboutus" component={AboutUs} />
    <Route exact path="/aboutus/history" component={AboutUs2} />
    <Route exact path="/products" component={Catalogue} />
    <Route exact path="/detail/*" component={Products} />
    <Route exact path="/content" component={Content} />
    <Route exact path="/ContentExp/*" component={ContentExp} />
    <Route exact path="/contact" component={Contact} />
    <Route exact path="/admin" component={Admin} />
    <Route exact path="/admin/edit" component={Editblog} />
    <Route exact path="/upload" component={UploadImg} />
  </Switch>
);

export default Routes;
